:host {
  display: block;
  max-width: 100%;
  min-width: 1100px;
  background: var(--white-layout-301-level-0-elevation);
}

.wrapper {
  padding: 2px;
}

.card-section {
  padding-top: calc(var(--spacer) * 1);
}

.container-section,
.card-section {
  max-width: 1920px;
}

.footer {
  margin-top: calc(var(--spacer) * 7);
}

.section-title {
  padding: calc(var(--spacer) * 7) calc(var(--spacer) * 4.6) calc(var(--spacer) * 3) calc(var(--spacer) * 4.7);
}

.faq-section {
  padding: calc(var(--spacer) * 16) calc(var(--spacer) * 8) 0 0;
  flex: 1;
}

.card-section-container,
.accordion-container {
  padding: 0 calc(var(--spacer) * 4) 0 0;
}

.card-section-container {
  padding-left: calc(var(--spacer) * 2.1);
}

gz-trial-product-item,
.footer {
  background-color: var(--chart-050-hover);
}

gz-card {
  min-height: auto;
  border: none;
  box-shadow: none;
  --hover-color: var(--white-layout-302-level-1-elevation);
  --title-margin-bottom: calc(var(--spacer) / 2);
}

gz-card::part(icon) {
  margin-top: 0;
}

.card-description {
  line-height: 1.3;
}

.accordion-container {
  width: 60%;
}

.image {
  width: 50%;
}

.faq-image-container {
  padding: calc(var(--spacer) * 6) calc(var(--spacer) * 12.5) calc(var(--spacer) * 6) calc(var(--spacer) * 12.5);
}

.faq-image {
  width: 317px;
}

.img-accordion-container {
  width: 650px;
  height: 350px;
  margin-left: 40px;

  &.has-outline {
    outline: 1px solid var(--chart-100-pressed);
  }
}

.img-accordion-container .imageAccordion {
  object-fit: cover;
  transform: translate3d(0, 0, 1px);
  width: inherit;
  height: inherit;
}

.trial-start-btn {
  display: block;
}
.trial-request-btn {
  display: block;
}
.trial-stop-btn {
  display: none;
}

.trial-start-btn {
  &:not(.is-start-available) {
    display: none;
  }
}
.trial-request-btn {
  &:not(.is-request-available) {
    display: none;
  }
}
.trial-stop-btn {
  &.is-stop-available {
    display: block;
  }
}

.view-demo-btn {
  &:not(.is-demo-available) {
    display: none;
  }
}

.how-to-btn {
  &:not(.is-how-to-available) {
    display: none;
  }
}

gz-count-down {
  position: absolute;
  padding-top: calc(var(--spacer) * 4);
  left: 50%;
  width: auto;
  height: auto;
}

@media (min-width: 1920px) {
  .accordion-container {
    max-width: 975px;
  }
  .faq-section {
    max-width: 1430px;
  }
}

gz-accordion::part(slotContent) {
  line-height: 1.3;
}
//msp trial related action buttons
.msp-trial-action-buttons-wrapper {
  min-height: 225px;

  .action-button {
    position: relative;
    border-radius: 4px;
    border: 1px solid var(--chart-101-pressed-dividers);
    padding: 24px 42px;

    &-description {
      margin-bottom: 24px;
    }
    &-title {
      font-size: var(--body-size-large);
      font-weight: 600;
      margin-bottom: 4px;
    }
    &-text {
      font-size: 12px;
      line-height: 18px;
      margin-bottom: 50px;
    }
    &-submit {
      position: absolute;
      bottom: 24px;
      left: 42px;
    }
  }
}

.trial-disclaimer {
  color: var(--chart-300-icon-buttons);
}
